import React, { useEffect, useState } from "react";

import "./FollowUpPatients.css";
import "../../Components/Commons/Commons.css";

import SidebarMenu from "../../Components/Sidebar/Sidebar";
import AntDTable from "../../Components/AntDTable/AntDTable";
import DeleteModal from "../../Components/Modals/DeleteModal";
import SelectField from "../../Components/Commons/Forms/SelectField";
import ConfirmModal from "../../Components/Modals/ConfirmModal";
import AppointmentModal from "../../Components/Modals/AppointmentModal";

import { useNavigate } from "react-router-dom";
import { 
  DatePicker,
  Button,
  Row,
  Col,
  Space,
} from "antd";
import {
  cancelSchedule,
  getFollowUpPatients,
  updateSchedule,
} from "../../Components/Helpers/API/FollowUpPatientsApi/FollowUpPatientsApi";
import { formatDate, getRole } from "../../Components/Helpers/Utilities/Common";
import { toast } from "react-toastify";
import { getAllDoctors } from "../../Components/Helpers/API/DoctorApi/DoctorApi";

function FollowUpPatients() {
  const navigate = useNavigate();
  const role = getRole();
  const [showDelete, setShowDelete] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);
  const [showReschedule, setShowReschedule] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const [rescheduledDate, setRescheduledDate] = useState("");
  const [data, setData] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [doctors, setDoctors] = useState([]);

  //Function for getting the value of filter select date
  const onDateChange = (date, dateString) => {
    get({ scheduled_on: dateString });
  };

  //onChange of all input fields
  const handleSelectChange = (event, row) => {
    setSelectedRow(() => row.row);
    if (event.target.value === "reschedule") {
      setRescheduledDate(
        new Date(row.row._scheduled_on).toISOString().split("T")[0]
      );
      setShowReschedule(true);
    } else if (event.target.value === "cancel") {
      setShowCancelConfirmation(true);
    }
  };

  // Function for action buttons in table
  function ActionBtn(row) {
    return (
      <>
        <Row className="center mb-2">
          <Space>
            {(role === "director" || role === "pcp" || role === "specialist") && (
              <Button
                className="primary-btn"
                onClick={() => {
                  navigate("/patients/profile/" + row.row.patient_id, {
                    // state: {
                    //   isTrue: false,
                    //   isCheck: true,
                    //   vitalSign: "medical_history",
                    //   // forCheckUp: true,
                    // },
                    state: {
                      doctor_id: row.row.doctor_id
                    },
                  })
                  localStorage.setItem("isCheck", JSON.stringify(true));
                  localStorage.setItem("isTrue", JSON.stringify(false));
                  localStorage.setItem("vitalSignLab", JSON.stringify('medical_history'));
                }
              }
              >
                Check Up
              </Button>
            )}
            <Button
              className="primary-btn"
              onClick={(e) =>
                navigate("/patients/profile/" + row.row.patient_id)
              }
            >
              View
            </Button>
          </Space>
        </Row>
        <Row className="center">
          <Space>
            <SelectField
              outline
              className="form-select action-btn cancel-clear-select edit-button"
              name="sex"
              size={`sm`}
              options={[
                { value: "", label: "Edit Schedule" },
                { value: "cancel", label: "Cancel Schedule" },
                { value: "reschedule", label: "Reschedule" },
              ]}
              onChange={(event) => handleSelectChange(event, row)}
            />
          </Space>
        </Row>
      </>
    );
  }

  // Function for get all doctors API
  async function fetchAllDoctors() {
    const response = await getAllDoctors();
    if (response.data) {
      setDoctors(response.data.data);
    } else {
      setDoctors([]);
    }
  }

  // get follow up patient API
  async function get(filterConfig) {
    setShowLoader(true);
    const res = await getFollowUpPatients(filterConfig);
    if (res.data) {
      const _data = res.data.data.map((patient) => {
        return {
          ...patient,
          _scheduled_on: patient.scheduled_on,
          scheduled_on: formatDate(patient.scheduled_on),
        };
      });
      setData(_data);
    } else if (res.error) {
      setData([]);
    }
    setShowLoader(false);
  }

  //cancel patient schedule API
  async function cancel() {
    const res = await cancelSchedule(selectedRow.id);
    if (res.data) {
      toast.success(res.data.message);
      setShowCancelConfirmation(false);
      get();
    } else if (res.error) {
      toast.error(res.error.data.messages.error_messages[0]);
    }
  }

  //edit schedule API
  async function reschedule() {
    const res = await updateSchedule({
      followup_id: selectedRow.id,
      patient_id: selectedRow.patient_id,
      scheduled_on: rescheduledDate,
      doctor_id: selectedDoctor !== null ? selectedDoctor : "",
    });
    if (res.data) {
      toast.success(res.data.message);
      setShowReschedule(false);
      get();
    } else if (res.error) {
      toast.error(res.error.data.messages.error_messages[0]);
    }
  }

  useEffect(() => {
    fetchAllDoctors();
    get();
  }, []);

  return (
    <div className="App">
      <SidebarMenu active={"Follow up Patients"} />
      <div className="col p-5 pt-4 manager-container all-container overflow-y">
        <div className="row pt-2 p-3">
          <div className="col font-big title-2 all-patient">Follow Up Patients</div>
        </div>
        <Row>
          <Col>
            <div className="row justify-content-start">
              <div className=" pl-0 mb-3">
                <DatePicker onChange={onDateChange} />
              </div>
            </div>
          </Col>
        </Row>
        <div className="row justify-content-center">
          <div className="col-sm-12 all-table">
            {role !== "nurse" ? (
              <>           
                <AntDTable
                  tableHeaders={["SCHEDULE", "NAME", "AGE", "GENDER", "CONTACT"]}
                  headerSelector={[
                    "scheduled_on",
                    "formatted_patient_name",
                    "patient_age",
                    "patient_sex",
                    "patient_phone_no",
                  ]}
                  tableData={data}
                  ActionBtn={(row) => ActionBtn(row)}
                  withAction={true}
                  loading={showLoader}
                />             
              </>
            ) : (
              <>
                <AntDTable
                  tableHeaders={["SCHEDULE", "NAME", "AGE", "GENDER", "CONTACT", "ASSIGNED TO"]}
                  headerSelector={[
                    "scheduled_on",
                    "formatted_patient_name",
                    "patient_age",
                    "patient_sex",
                    "patient_phone_no",
                    "doctor_name"
                  ]}
                  tableData={data}
                  ActionBtn={(row) => ActionBtn(row)}
                  withAction={true}
                  loading={showLoader}
                />
              </>
            )}
          </div>
        </div>
      </div>
      <ConfirmModal
        show={showCancelConfirmation}
        onHide={() => setShowCancelConfirmation(false)}
        onConfirm={() => cancel()}
        message={`Are you sure you want to cancel the schedule of ${selectedRow.patient_name}?`}
      />
      <AppointmentModal
        title={`Reschedule Date`}
        show={showReschedule}
        onHide={() => setShowReschedule(false)}
        onConfirm={() => reschedule()}
        doctorsData={doctors}
        selectedDoctor={selectedDoctor}
        setSelectedDoctor={setSelectedDoctor} // Pass function to update doctor
        defaultDate={rescheduledDate}
        setRescheduledDate={setRescheduledDate}
        saveTitle={`Save changes`}
      />
      <DeleteModal show={showDelete} onHide={() => setShowDelete(false)} />
    </div>
  );
}

export default FollowUpPatients;
